<template>
	<div class="employerList">
		<!-- Main Body Content area -->
        <div class="o-main-content-area">
            <!-- Heading Section -->
            <div class="row c-responsive-fixwidth">
                <div class="col-md-2">
                    <h1 class="h1">Employer</h1>
                </div>
                <div class="col-md-10 text-right">
                    <ul class="o-filter-area">

                        <li class="o-search-field">
                           <div class="input-group stylish-input-group">
                                <input v-model="searchData" v-on:keyup="getEmployerList()" type="text" class="form-control" placeholder="Search">
                                <!-- <span class="input-group-addon">
                                    <button type="submit">
                                        <span class=""><i class="fa fa-search" aria-hidden="true"></i></span>
                                    </button>
                                </span> -->
                            </div>

                        </li>
                        <li v-if="getPower('addEmployer')"><a href="javascript: void(0)" @click="addNewEmployer()" class="c-common-btn c-common-btn--green"><i class="fa fa-plus" aria-hidden="true"></i> Add new Employer</a></li>

                        <li v-if="getPower('deleteEmployer')"><a href="javascript: void(0)" @click="deleteEmployers()" class="c-common-btn c-common-btn--red"><i class="fa fa-trash-o" aria-hidden="true"></i> Delete Employer</a></li>

                        <!-- <li><a @click="addCSV()" class="c-common-btn c-solid-btn--blue"><i class="fa fa-upload" aria-hidden="true"></i> Import Through CSV</a></li> -->
                    </ul>

                </div>
            </div>
            <!-- /Heading Section -->
        </div>
        <div class="o-ndividualArea c-responsive-fixwidth">
            <div class="o-ndividualTable">
                <div class="c-common-space o-individual-calls">
                    <div class="col-md-12 o-no-padding">
                        <form class="form-inline">
                            <div class="form-group">
                                <label class="common-label-text">Sort By:</label>
                                <div class="o-cutsomSelect o-cutsomSelect--fixedwidth">
                                    <select @change="getEmployerList()" v-model="selectedSortType">
                                        <option value="name">Name</option>
                                        <option value="email">Email ID</option>
                                    </select>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <div class="o-skills-listing">
                    <div class="row">

                        <div class="col col-sm-12">
                           <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10" class="o-scheduleTable--daily" v-loading="loading">

                                <div class="o-calls-table c-common-gradient c-common-box-shadow c-radius3 c-margin-bottom-10 employer-list-table-align" v-for="employer in employers" :key="employer.id">
                                        <div class="calls-table-row">

                                            <div @click="employerDetails(employer.employer_id)" class="calls-table-cell">
                                                <div class="table-td-border-right">
                                                    <div class="calls-table-cell-inner-table o-modal-trigger" data-toggle="modal" data-target="#employeeSummaryModal">
                                                        <div class="o-accordion-subtext user-icon o-list-user-img">
                                                            <div class="o-post-logged o-post-logged--table-user">
                                                                <div class="o-user-profile-img">

                                                                    <img v-if="employer && employer.employer!=null && employer.employer.image != '' && employer.employer.image != 'NULL' && employer.employer.image != null" :src="(employer.employer.image)" id='img-upload' />
                                                                    <img v-else src="static/assets/images/user1.png" id='img-upload' />

                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="o-accordion-subtext o-rowtable-text">
                                                            <span>Name</span>
                                                            <div>{{employer && employer.employer ?employer.employer.name:'--'}}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="calls-table-cell">
                                                <div class="table-td-border-right">
                                                <div class="calls-table-cell-inner-table">
                                                    <div class="o-accordion-subtext o-rowtable-text">
                                                        <span>Contact:</span>
                                                        <div v-if="employer && employer.employer && employer.employer.employer_users">
                                                            <P v-for="user in employer.employer.employer_users" :key="user.id">
                                                                {{user.user?user.user.first_name:''}}
                                                            </P>
                                                        </div>
                                
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="calls-table-cell">
                                            <div class="table-td-border-right">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>Email ID:</span>
                                                    <div v-if="employer && employer.employer && employer.employer.employer_users">
                                                        <P v-for="user in employer.employer.employer_users" :key="user.id">{{user.user?user.user.email:''}}</P>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="calls-table-cell">
                                            <div class="table-td-border-right">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>Phone:</span>
                                                    <div v-if="employer && employer.employer && employer.employer.phones" >
                                                        <div v-if="phones.label != 'Fax'" v-for="phones in employer.employer.phones" :key="phones.id">      
                                                            <!-- {{getPhoneNumber(phones)}} -->
                                                            <a :href="'tel:'+getClientContactFormat(phones.phone_number)" class="phone-number-display">
                                                                {{ phones.phone_number ? getClientContactFormat(phones.phone_number) : '' }}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="calls-table-cell"> 
                                            <div class="table-td-border-right">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>FAX:</span>
                                                    <div v-if="employer && employer.employer && employer.employer.phones" >
                                                        <div v-if="phones.label == 'Fax'" v-for="phones in employer.employer.phones" :key="phones.id">
                                                            <!-- {{getPhoneNumber(phones)}} -->
                                                            <a :href="'tel:'+getClientContactFormat(phones.phone_number)" class="phone-number-display">
                                                                {{ phones.phone_number ? getClientContactFormat(phones.phone_number) : '' }}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="calls-table-cell">
                                            <div class="">
                                                <div class="o-accordion-subtext o-rowtable-text o-notify-cell" :class="getPower('notify')?'':'notify-tab-hide'">
                                                    <span class="">Notify</span>
                                                    <div class="notify-icon">
                                                    <a href="javascript: void(0)" @click="addBatchNotify(employer)"><i class="fa fa-mobile" aria-hidden="true"></i></a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="calls-table-cell text-center o-no-padding">
                                            <div class="o-edit-trash o-no-padding">

                                                <div class="o-table-block-btn">
                                                    <a :class="{'disabled':!getPower('editEmployer')}" href="javascript: void(0)" @click="editEmployer(employer)"><i class="fa fa-pencil" aria-hidden="true"></i></a>
                                                </div>
                                                <div class="o-table-block-btn">
                                                    <a :class="{'disabled':!getPower('deleteEmployer')}" href="javascript: void(0)" @click="deleteSingleEmployer(employer.employer_id)"><i class="fa fa-trash-o" aria-hidden="true"></i></a>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="employers.length <= 0 && afterAPI" class="c-common-space c-common-gradient c-common-box-shadow c-radius3">
                                   <div class="col-md-12 no-job-dispaly">
                                      <i class="fa fa-frown-o" aria-hidden="true"></i>
                                      <br />
                                       No Data Stored
                                   </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
        <!-- /Main Body Content area -->
        <modal name="add-csv"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
            <div id="" class="modal-add-call" tabindex="-1" role="dialog">
                <div  role="document">
                    <div class="modal-content o-common-modal-content">
                        <div class="modal-header u-no-border text-center modal-header--heading">
                            <button @click="closeCSV()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></button>
                            <h1 class="modal-title">Import CSV</h1>
                        </div>
                        <div class="modal-body c-common-box-shadow o-modal-body">

                                <div class="row">
                                <div class="col-sm-12">
                                        <div class="col-sm-12 o-modal-field-area">
                                            Test
                                        </div>
                                    </div>
                                </div>

                        </div>
                    <div class="modal-footer text-center">
                        <ul class="o-filter-area">
                            <li>
                                <a href="javascript: void(0)" @click="closeCSV()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                            </li>
                            <li>
                                <a href="javascript: void(0)" @click="" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-save"></i> Save</a>
                            </li>
                        </ul>
                    </div>
                    </div>
                    <!-- /.modal-content -->
                </div>

                <!-- /.modal-dialog -->
            </div>
        </modal>

        <modal name="batch-notify"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
            <div class="modal-add-newJob" tabindex="-1" role="dialog">
                <div  role="document">
                    <div class="modal-content o-common-modal-content">
                        <div class="modal-header u-no-border text-center o-small-modal-head">
                            <button @click="closeBatchNotify()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            <h4 class="modal-title">Notify</h4>
                        </div>
                        <div class="modal-body c-common-box-shadow o-modal-nopad-body">
                            <div class="row">
                                <div class="col-sm-12">
                                  <ul class="o-modal-tab">
                                      <li v-if="getNotificationType=='email'"><a href="javascript: void(0)" @click="notifyEmailTab()" :class="(notifyTab == 'email')?'o-tab-active':''">Email</a></li>
                                      <li v-if="getNotificationType=='sms'"><a href="javascript: void(0)" @click="notifySmsTab()" :class="(notifyTab == 'sms')?'o-tab-active':''">SMS</a></li>
                                  </ul>
                                </div>
                                <div class="col-sm-12" v-if="notifyTab == 'email'">
                                   <div class="form-group o-attachment-sec">
                                       <vue-editor class="" v-model="emailContent"></vue-editor>

                                       <div class="common-label-input--modalwidth o-upload-file attachment-btn-wrapper">
                                            <button class="btn o-attachment-icon"><i class="fa fa-paperclip" aria-hidden="true"></i></button>
                                            <input type="file" name="myfile" @change="attachmentAdded($event)">
                                            <span>{{(attachment)?attachment.name:'No file chosen'}}</span>
                                        </div>

                                    </div>
                                </div>
                                <div class="col-sm-12" v-if="notifyTab == 'sms'">
                                  <div class="o-sms-counter o-sms-counter-normal">{{smsContent.length}}/160</div>
                                   <textarea maxlength="160" v-model="smsContent" class="form-control o-no-radius notifySms-field" rows="10" placeholder="Type your SMS"></textarea>
                                </div>
                            </div>

                        </div>
                        <div class="modal-footer text-center">
                            <ul class="o-filter-area">
                                <li>
                                    <a href="javascript: void(0)" @click="closeBatchNotify()" data-dismiss="modal" aria-label="Close" class="btn c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                                </li>
                                <li>
                                    <a href="javascript: void(0)" @click="sendNotify()" class="btn c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-paper-plane" aria-hidden="true"></i> Send</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <!-- /.modal-content -->
                </div>
                <!-- /.modal-dialog -->
            </div>
       </modal>

	</div>
</template>
<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import {
        VueEditor
    } from 'vue2-editor';
    import service from '../../services.js';
    import {
        global
    } from '../../global.js';
    import dateTimeConvert from '../../timeConvert&Compare';
    export default {
        components: {
            VueEditor
        },
        data() {
            return {
                loading:false,
                afterAPI:false,
                data: '',
                employers: [],
                nextPageUrl:null,
                storeMore:[],
                searchData: '',
                selectedSortType: 'name',
                searchBox: '',
                getBaseURL: '',
                selectedEmployerId: '',
                emailContent: '',
                smsContent: '',
                notifyTab: 'email',
                attachment : null,
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                getNotificationType: 'getNotificationType',
                //jobID: 'selectedJobId',
            })
        },
        methods: {
            getClientContactFormat(phone) {
                phone = phone ? phone.toString() : '';
                phone = phone.replace(/-/g, "");
                phone = phone.replace(/ /g, "");
                phone = phone.replace("(", "");
                phone = phone.replace(")", "");
                let result = '';
                if(phone&&phone.length==10) { 
                    // console.log(phone);
                    result = '+1'+phone;
                }else if(phone&&phone.length==11) {
                    // console.log(phone);
                    result = '+' + phone;
                }else if(phone&&phone.length) {
                    result = phone;
                }
                return result;
                // return phone;
            },
            getPower(data) {
                //console.log('headernav',typeof dateTimeConvert.checkAccess(data));
                return dateTimeConvert.checkAccess(data);
            },
            addNewEmployer() {
                this.$router.push({
                    path: `/addEmployer`
                });
            },
            editEmployer(employer) {
                // console.log(employer);
                this.$router.push({
                    path: `/editEmployerClient/`+btoa(employer.employer_id)
                });
            },
            employerDetails(id) {
                this.$router.push({
                    path: `/employerDetails/`+btoa(id)
                });
            },
            // for go to bulk delete page
            deleteEmployers() {
                this.$router.push({
                    path: `/deleteEmployers`
                });
            },
            //for delete a single employer
            deleteSingleEmployer(id) {
                this.$confirm('COMPANY will be removed the the records of CLIENT. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.$Progress.start();
                    service.del('employer/' + id +'/removeClientEmployerAssociation', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    }).
                    then((res) => {
                        this.$Progress.finish();
                        //console.log(this.employers);
                        this.$notify({
                            title: this.$t('success'),
                            message: 'Employer Deleted Successfully.',
                            type: 'success'
                        });
                        this.getEmployerList();
                    }).catch((err) => {
                        console.log(err);
                        this.$Progress.finish();
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Delete canceled'
                    });
                });
            },
            getPhoneNumber(phones) {
                // console.log(phones);
                // return ("(" + phones.phone_number.substr(0, 3) + ") " + phones.phone_number.substr(3, 3) + "-" + phones.phone_number.substr(6));
                let phoneNumberString=phones.phone_number;
                let cleaned = ('' + phoneNumberString).replace(/\D/g, '')
                  let match = cleaned.match(/^(\d{3})(\d{3})(\d+)$/)
                  if (match) {
                    return '(' + match[1] + ') ' + match[2] + '-' + match[3]
                  }
                  return null
            },
            getEmployerList() {
                this.$Progress.start();
                this.loading=true;
                this.afterAPI=false;
                service.get('employer/clientEmployerListing', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'sort-type': this.selectedSortType,
                    'search': this.searchData,
                    'pagination': true 
                }).
                then((res) => {
                    this.employers = res.data.result.data;
                    this.$Progress.finish();
                    this.loading=false;
                    this.afterAPI=true;
                    this.nextPageUrl = res.data.result.next_page_url;
                    if (this.nextPageUrl != null) {
                        service.getUrl(this.nextPageUrl, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                            'sort-type': this.selectedSortType,
                            'search': this.searchData,
                            'pagination': true 
                        })
                        .then((res) => {
                            this.storeMore = res.data.result.data;
                            this.nextPageUrl = res.data.result.next_page_url;
                            this.$Progress.finish();
                        }).catch((err) => {
                            console.log(err);
                            this.$Progress.finish();
                        })
                    } 

                }).catch((err) => {
                    console.log(err);
                    this.$Progress.finish();
                    this.loading=false;
                    this.afterAPI=true;
                });
            },
            loadMore() {
                if (this.storeMore.length != 0) {
                    var arr = this.employers;
                    this.storeMore.forEach(function(data) {
                        arr.push(data);
                    });
                    this.storeMore = [];
                    if (this.nextPageUrl != null) {
                        service.getUrl(this.nextPageUrl, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                            'sort-type': this.selectedSortType,
                            'search': this.searchData,
                            'pagination': true 
                        })
                        .then((res) => {
                            this.storeMore = res.data.result.data;
                            this.nextPageUrl = res.data.result.next_page_url;
                            this.$Progress.finish();
                        }).catch((err) => {
                            console.log(err);
                            this.$Progress.finish();
                        })
                    } else {
                        this.storeMore = [];
                    }

                }
                //console.log('loading..');
            },
            addBatchNotify(employer) {
                console.log(employer);  
                // Not clear about api request
            },
            sendNotify() {
                // Not clear about api request
            },
            closeBatchNotify() {
                // Not clear about api request

            },
            attachmentAdded(event) {
                console.log(event);
                // Not clear about api request
            }
        },
        beforeMount() {
            this.getEmployerList();
        }
    }

</script>
<style scoped>
.phone-number-display{
    padding: 5px;
    cursor: pointer;
    color: #222222;
    text-decoration: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/employers/employerList.vue